var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1784 10L14.7559 6.42253C15.0814 6.09701 15.0814 5.56966 14.7559 5.24414C14.4303 4.91862 13.903 4.91862 13.5775 5.24414L10 8.82161L6.42253 5.24414C6.09701 4.91862 5.56966 4.91862 5.24414 5.24414C4.91862 5.56966 4.91862 6.09701 5.24414 6.42253L8.82161 10L5.24414 13.5775C4.91862 13.903 4.91862 14.4303 5.24414 14.7559C5.4069 14.9186 5.62012 15 5.83333 15C6.04655 15 6.25977 14.9186 6.42253 14.7559L10 11.1784L13.5775 14.7559C13.7402 14.9186 13.9535 15 14.1667 15C14.3799 15 14.5931 14.9186 14.7559 14.7559C15.0814 14.4303 15.0814 13.903 14.7559 13.5775L11.1784 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.cf9564652cad44ca2ba749750ed012ec.svg";
export { ForwardRef as ReactComponent };